export const Apis = {
  DEV: 'http://192.168.18.12:8080/xpromsalud',
  PROD: 'https://46.202.147.207/xpromsalud'
  // PROD: 'http://192.168.18.12:8080/xpromsalud'
}
